import React, { useState } from "react"
import { Link } from "react-router-dom"
import LF50Logo from "../images/Lowfye_Logo_full_name_blue.png"
import { BAND_EMAIL } from "../links"
import "./Nav.css"

const EPK_SECTIONS = [
    { id: "epk-video", label: "VIDEO" },
    { id: "epk-music", label: "MUSIC" },
    { id: "epk-bio", label: "BIO" },
    { id: "epk-photos", label: "PHOTOS" },
    { id: "epk-rider", label: "RIDER" },
]

// scroll without adding a #hash to the URL, so the EPK link stays clean when shared
export const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
}

const bookingLink = `mailto:${BAND_EMAIL}?subject=${encodeURIComponent("Booking inquiry - Lowfye50")}`

export const NavBarEpk = () => {
    const [menuOpen, setMenuOpen] = useState(false)

    return (
        <nav className={`lf-nav lf-nav--epk ${menuOpen ? "lf-nav--open" : ""}`}>
            <div className="lf-nav__inner">
                <div className="lf-nav__brandGroup">
                    <Link to="/" className="lf-nav__brand">
                        <img src={LF50Logo} alt="Lowfye50 main site" />
                    </Link>
                    <span className="lf-nav__badge">PRESS KIT</span>
                </div>

                <ul className="lf-nav__links">
                    {EPK_SECTIONS.map(section => (
                        <li key={section.id}>
                            <button
                                onClick={() => {
                                    setMenuOpen(false)
                                    scrollToSection(section.id)
                                }}
                            >
                                {section.label}
                            </button>
                        </li>
                    ))}
                    <li className="lf-nav__mainSite">
                        <Link to="/">MAIN SITE <i className="fas fa-arrow-right"></i></Link>
                    </li>
                </ul>

                <div className="lf-nav__actions">
                    <a className="lf-btn lf-btn--primary lf-nav__cta" href={bookingLink}>
                        <i className="fas fa-envelope"></i> <span>Book the band</span>
                    </a>
                    <button
                        className="lf-nav__toggle"
                        aria-label={menuOpen ? "Close menu" : "Open menu"}
                        aria-expanded={menuOpen}
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <i className={menuOpen ? "fas fa-times" : "fas fa-bars"}></i>
                    </button>
                </div>
            </div>
        </nav>
    )
}
